const system = {
  menuManager: {
    menu: "菜单",
    button: "按钮",
    menuName: "菜单名称(中文)",
    menuNameEn: "菜单名称(英文)",
    link: "链接",
    menuType: "菜单类型",
    sort: "排序号",
    isShow: "是否显示",
    weight: "菜单权重",
    otherWeight: "附加权重",
    create: "新增",
    update: "编辑",
    delete: "删除",
    topLevelMenu: "顶层菜单",
    parentMenu: "父级菜单",
    icon: "图标",
    hide: "隐藏",
    show: "显示",
    permission: "权限标识",
    msg: {
      error1: "请输入中文菜单名称",
      error2: "请输入排序号",
      error3: "请输入中文菜单名称",
      error4: "请选择菜单权重"
    },
    weightList: {
      list1: "开发人员",
      list2: "V2x",
      list3: "渠道商",
      list4: "企业",
      list5: "经销商",
      list6: "门店"
    },
    rightLabelWidth: "110px",
    leftLabelWidth: "110px"
  },
  repair: {
    searchTitle: "项目名称",
    searchTitle1: "项目分组",
    searchName: {
      first: "常规维修",
      second: "其他维修"
    },
    itemName: "项目名称",
    itemNameEn: "项目英文名称",
    itemType: "项目分组",
    readOnly: "由我创建",
    createdOn: "创建时间",
    tableWidth: {
      itemName: "100",
      itemNameEn: "100",
      itemType: "100",
      createdOn: "110",
      readOnly: "100"
    },
    create: "新增维修",
    update: "编辑维修",
    msg: {
      error1: "请输入项目名称",
      error2: "请输入项目英文名称",
      error3: "请选择项目分组",
      readOnly: "否",
      editable: "是",
      readOnlyTip: "您无权操作此项"
    }
  },
  maintenance: {
    searchTitle: "项目名称",
    searchTitle1: "项目分组",
    searchName: {
      first: "基本保养",
      second: "深度保养",
      third: "清洁保养",
      custom: "自定义"
    },
    itemName: "项目名称",
    itemNameEn: "项目英文名称",
    itemType: "项目分组",
    readOnly: "由我创建",
    createdOn: "创建时间",
    tableWidth: {
      itemName: "100",
      itemNameEn: "100",
      itemType: "100",
      createdOn: "110",
      readOnly: "100"
    },
    create: "新增保养",
    update: "编辑保养",
    msg: {
      error1: "请输入项目名称",
      error2: "请输入项目英文名称",
      error3: "请选择项目分组",
      readOnly: "否",
      editable: "是",
      readOnlyTip: "您无权操作此项"
    }
  },
  user: {
    searchName: "账号 / 姓名",
    loginAccount: "登录账号",
    userName: "真实姓名",
    role: "角色",
    lockStatus: "锁定状态",
    userRole: "用户角色",
    accountType: "账号类型",
    accountStatus: "账号状态",
    enable: "启用",
    ban: "禁用",
    restPwdTips: "请选择要重新设定密码的用户",
    openingTime: "开通时间",
    searchLabelWidth1: "80px",
    yes: "是",
    no: "否",
    labelWidth: "80px",
    msg1: "重置后密码为12345678",
    msg2: "重置密码成功",
    tips: "请选择需要重置项",
    passwordTips: "请选中需要重设密码项",
    tableWidth: {
      loginAccount: "100",
      userName: "100",
      accountStatus: "100",
      phoneNumber: "110",
      openingTime: "140"
    },
    createAndUpdate: {
      create: "新增用户",
      update: "编辑用户",
      msg: {
        error1: "请输入登录账号",
        error2: "请输入用户姓名",
        error3: "请选择角色"
      }
    },
    banTips: "禁用用户"
  },
  defaultPwd: "默认密码",
  logs: {
    login: {
      loginAccount: "登录账号",
      userName: "用户姓名",
      clientIP: "客户端IP",
      resultsLogin: "登录结果",
      accountType: "账号类型",
      loginTime: "登录时间",
      clientBrowser: "客户端浏览器",
      searchWidth: {
        width1: "60px",
        width2: "60px",
        width3: "60px",
        width4: "60px"
      },
      success: "成功",
      fail: "失败"
    },
    oper: {
      loginAccount: "登录账号",
      userName: "用户姓名",
      clientIP: "客户端IP",
      roleName: "用户角色",
      operatingFunctions: "操作功能",
      operatingActions: "操作动作",
      operationDescription: "操作描述",
      operatingTime: "操作时间",
      browserInformation: "浏览器信息",
      operatingResults: "操作结果",
      searchWidth: {
        width1: "60px",
        width2: "60px",
        width3: "60px",
        width4: "60px"
      },
      tableWidth: {
        loginAccount: "100",
        userName: "100",
        roleName: "100",
        operatingFunctions: "140",
        operatingResults: "100",
        browserInformation: "150"
      }
    },
    lifecycle: {
      loginAccount: "登录账号",
      userName: "用户姓名",
      accountType: "账号类型",
      logDescription: "日志描述",
      logType: "日志类型",
      operatingTime: "操作时间",
      operator: "操作人",
      operationDescription: "操作描述",
      searchWidth: {
        width1: "60px",
        width2: "60px",
        width3: "60px",
        width4: "60px"
      },
      tableWidth: {
        loginAccount: "100",
        userName: "100",
        operator: "100",
        accountType: "100",
        roleName: "100",
        logType: "150",
        operatingTime: "240"
      }
    }
  },
  role: {
    name: "角色名称",
    searchLabelWidth: "60px",
    remark: "备注",
    isSys: "系统角色",
    dataScope: "数据权限",
    datascope0: "未设置",
    datascope1: "全部",
    tips: "请选中需要设置项",
    tableWidth: {
      name: "130px",
      isSys: "80px",
      dataScope: "150px"
    },
    create: "新增角色",
    update: "编辑角色",
    basicInfo: "基本信息",
    menu: "授权功能菜单",
    error: "请输入角色名称"
  },
  channel: {
    create: "新增渠道商管理员",
    update: "编辑渠道商管理员",
    name: "渠道商名称",
    channelLabelWidth: "75px",
    info: "渠道商信息",
    valid: {
      name: "请输入渠道商名称"
    }
  },
  company: {
    name: "企业名称",
    searchLabelWidth: "60px",
    remark: "备注",
    tableWidth: {
      name: "130px",
      isSys: "80px",
      dataScope: "150px"
    },
    create: "新增企业",
    update: "编辑企业",
    info: "企业信息",
    admin: "管理员信息",
    adminAccount: "管理员账号",
    adminRealName: "管理员姓名",
    phoneNumber: "手机号码",
    dialogLabelWidth: "82px",
    valid: {
      name: "请输入企业名称",
      account: "请输入管理员账号",
      realName: "请输入管理员姓名",
      mobile: "手机号码格式不正确"
    },
    obdCount: "已授权OBD",
    addObd: "新增OBD授权",
    removeObd: "取消OBD授权"
  },
  subCompany: {
    name: "经销商名称",
    subCompanyLabelWidth: "80px",
    create: "新增经销商",
    update: "编辑经销商",
    info: "经销商信息",
    valid: {
      name: "请输入经销商名称"
    }
  },
  department: {
    name: "门店名称",
    create: "新增门店管理员",
    update: "编辑门店管理员",
    departmentLabelWidth: "70px",
    info: "门店信息",
    valid: {
      name: "请输入门店名称"
    }
  },
  brand: {
    brand: {
      brandName: "品牌名称",
      brandIcon: "品牌图标",
      brandCode: "品牌编码",
      addBrand: "新增品牌",
      editBrand: "编辑品牌",
      selectIcon: "选择图标",
      carSeries: "车系",
      errorIcon: "请选择品牌图标",
      errorName: "请输入品牌名称",
      errorCode: "请输入品牌编码",
    },
    series: {
      seriesName: "车系名称",
      seriesCode: "车系编码",
      addSeries: "新增车系",
      editSeries: "编辑车系",
      carModel: "车型",
      goBackBrand: "返回品牌",
      errorName: "请输入车系名称",
      errorCode: "请输入车系编码",
    },
    model: {
      modelName: "车型名称",
      modelCode: "车型编码",
      addModel: "新增车型",
      editModel: "编辑车型",
      modelMaintenanceKm: "车辆保养公里数",
      modelMaintenanceTime: "保养时长",
      modelDisplacement: "排量",
      displacementUnit: "排量单位",
      modelCylinder: "汽缸数",
      modelYear: "年款",
      goBackSeries: "返回车系",
      errorName: "请输入车型名称",
      errorCode: "请输入车型编码",
    },
    brandLabelWidth: "65px",
    remark: "备注",
  },
  pdpa:{
    labelWidth:'80px',
    appName:'App名称',
    version: '版本号',
    createTime: '创建时间',
    thailandurl: '泰文url',
    englishurl: '英文url',
    fabu:'发布',
    yifabu:'已发布',
    tableWidth:{
      appName:'100px',
      version: '100px',
      createTime: '100px',
      thailandurl: '250px',
      englishurl: '250px',
    },
    labelWidth2:'110px',
    v2x:'V2X-A2',
    playconnect:'PlayConnect',
    typeSelect:'生效日期',
    thailand: '泰文',
    english: '英文',
    appTypemsg:'请选择App类型',
    effectiveDatemsg:'请选择生效时间',
    playCtyzt:'PlayConnect_PDPA同意状态',
    playCversion:'PlayConnect_PDPA版本',
    playCtime:'PlayConnect_PDPA同意时间',
    v2xtyzt:'V2X-A2_PDPA同意状态',
    v2xversion:'V2X-A2_PDPA版本',
    v2xtime:'V2X-A2_PDPA同意时间',
    tipsfabu:"是否确定发布？",
    ty:'同意',
    bty:'未同意'
  }
}
export default system